/* Stash Shop – colour image swatches on product cards (blocks/ss-card-swatches.liquid).
   Hover a swatch (or first tap on touch) to show that colour's image in the card; the card links then go to that colour.
   Click (or second tap) opens the product on that colour. Delegated, so cards added by infinite scroll work too. */
(() => {
  if (window.__ssCardSwatches) return;
  window.__ssCardSwatches = true;

  const cardOf = (sw) => sw.closest('product-card, .product-card') || sw.closest('li');

  function show(sw) {
    const card = cardOf(sw);
    if (!card) return;
    const id = sw.dataset.mediaId;
    const slideshow = card.querySelector('slideshow-component');
    // Select by slide id: Fabric hides other colours' variant slides, and select({ id }) reveals the hidden one
    if (slideshow && id && typeof slideshow.select === 'function' && slideshow.querySelector(`slideshow-slide[slide-id="${id}"]`)) {
      try {
        slideshow.select({ id }, undefined, { animate: false });
      } catch (e) {
        /* ignore */
      }
    }
    card.querySelectorAll('a.product-card__link, a[ref="cardGalleryLink"], a[ref="productCardLink"]').forEach((a) => {
      if (!a.dataset.ssHref) a.dataset.ssHref = a.getAttribute('href');
      a.setAttribute('href', sw.getAttribute('href'));
    });
    card.querySelectorAll('.ss-card-swatch').forEach((x) => {
      if (x !== sw) delete x.dataset.ssTapped;
      x.classList.remove('is-active');
    });
    sw.classList.add('is-active');
  }

  document.addEventListener('pointerover', (e) => {
    if (e.pointerType === 'touch') return;
    const sw = e.target.closest?.('.ss-card-swatch');
    if (sw) show(sw);
  });
  document.addEventListener('focusin', (e) => {
    const sw = e.target.closest?.('.ss-card-swatch');
    if (sw) show(sw);
  });
  let touchShown = null;
  document.addEventListener('pointerdown', (e) => {
    const sw = e.target.closest?.('.ss-card-swatch');
    if (!sw || e.pointerType !== 'touch') return;
    touchShown = sw.classList.contains('is-active') && sw.dataset.ssTapped === '1' ? null : sw;
  });
  document.addEventListener(
    'click',
    (e) => {
      const sw = e.target.closest?.('.ss-card-swatch, .ss-card-swatch__more');
      if (!sw) return;
      e.stopPropagation(); // keep the card's own click handling out; the link itself navigates
      if (touchShown === sw) {
        e.preventDefault();
        show(sw);
        sw.dataset.ssTapped = '1';
        touchShown = null;
      }
    },
    true
  );
})();
